module.exports = __webpack_public_path__ + "static/media/youth_can_logo.971d47ea.png";